import useGetWrappedWallet from '@/hooks/auth/useGetWrappedWallet';
import { delay } from '@/hooks/LitSessionContext/useLitAuth';
type HomePageProps = {};
type HomePageRef = React.ForwardedRef<HTMLDivElement>;
import Seo from '@/components/shared/Seo';
import SearchHome from '@/components/explore/SearchHome';
import MobileMenu from '@/components/shared/MobileMenu';
import FullScreenGuard from '@/components/auth/FullScreenGuard';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { LogToMixpanel } from '@/lib/mixpanel';
import { set } from 'date-fns';
type TradePageProps = {};
type TradePageRef = React.ForwardedRef<HTMLDivElement>;
export default function TradePage(props: TradePageProps, ref: TradePageRef) {
  const router = useRouter();
  const {
    getEVMWallet,
    getSolanaWallet
  } = useGetWrappedWallet();
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  useEffect(() => {
    async function replaceUrl(urlParams: URLSearchParams) {
      await delay(1000);
      urlParams.delete('message');
      const newUrl = `${window.location.pathname}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`;
      window.history.replaceState({}, '', newUrl);
    }
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    const message = urlParams.get('message');
    console.log('message', message);
    if (message) {
      setToastMessage(message);
      replaceUrl(urlParams);
    }
  }, [router]);
  useEffect(() => {
    if (toastMessage) {
      toast(toastMessage, {
        duration: 5000
      });
    }
  }, [toastMessage]);
  return <div className='bg-genius-indigo h-full max-h-screen' data-sentry-component="TradePage" data-sentry-source-file="index.tsx">
      <Seo title='Explore • Find the Hottest New Tokens on Genius Terminal • Trade Crypto Like a Genius' data-sentry-element="Seo" data-sentry-source-file="index.tsx" />
      <FullScreenGuard data-sentry-element="FullScreenGuard" data-sentry-source-file="index.tsx">
        <SearchHome setSelectToAsset={() => {
        return;
      }} desktop={false} data-sentry-element="SearchHome" data-sentry-source-file="index.tsx" />
        <MobileMenu data-sentry-element="MobileMenu" data-sentry-source-file="index.tsx" />
      </FullScreenGuard>
    </div>;
}